import { axios, API } from './config';

export const usersAPI = {
  getAll: async () => {
    const response = await axios.get(`${API}/users`);
    return response.data;
  },
  
  getById: async (id) => {
    const response = await axios.get(`${API}/users/${id}`);
    return response.data;
  },
  
  create: async (userData) => {
    const response = await axios.post(`${API}/users`, userData);
    return response.data;
  },
  
  update: async (id, userData) => {
    const response = await axios.put(`${API}/users/${id}`, userData);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await axios.delete(`${API}/users/${id}`);
    return response.data;
  }
};
